import { Component, Input } from '@angular/core';
import { BaseComponent } from '@components/base.component';
import {
    SeasonPlayerShotZones,
    SHOT_ZONES,
    ShotZoneStats,
    ShotZoneType,
    ShotZonesMap,
    ZoneTotals,
} from '@interfaces/shot-zones.interface';

type SeasonShotZonesTableRow = {
    key: string;
    seasonId: number;
    subtournamentId: number;
    seasonName: string;
    subtournamentName: string;
    total: ZoneTotals;
    average: ZoneTotals;
};

@Component({
    selector: 'app-season-player-shot-zones',
    templateUrl: './season-player-shot-zones.component.html',
})
export class SeasonPlayerShotZonesComponent extends BaseComponent {

    @Input()
    public shot_zones: SeasonPlayerShotZones[] | undefined;

    //@Input() sortField: 'goals' | 'shots' | 'missed_shots' | 'blocked_att' | 'shot_att' = 'goals';
    //@Input() sortDirection: 'asc' | 'desc' = 'desc';

    selectedZoneId: ShotZoneType | null = null;

    readonly shotZones = SHOT_ZONES;

    onZoneChange(zoneId: ShotZoneType | null) {
        this.selectedZoneId = zoneId;
    }

    zoneI18nKey(zone: ShotZoneType): string {
        return `web.shot-zone-ice-hockey-${zone.replace(/_/g, '-')}`;
    }

    get tableRows(): SeasonShotZonesTableRow[] {
        const data = this.shot_zones ?? [];
        const selected: ShotZoneType | null = this.selectedZoneId ?? null;

        const mapped = data
            .map(item => {
                const totalStats = item.statistics?.total ?? null;
                const avgStats = item.statistics?.average ?? null;

                const total = selected
                    ? this.toTotals(totalStats?.shot_zones?.[selected] ?? null)
                    : this.sumZones(totalStats?.shot_zones ?? {});

                const average = selected
                    ? this.toTotals(avgStats?.shot_zones?.[selected] ?? null)
                    : this.sumZones(avgStats?.shot_zones ?? {});

                // hide rows with zero values
                //if (!this.hasAnyValue(total) && !this.hasAnyValue(average)) return null;

                const seasonId = item.season?.id ?? 0;
                const subtournamentId = item.subtournament?.id ?? 0;

                return {
                    key: `${seasonId}-${subtournamentId}`,
                    seasonId,
                    subtournamentId,
                    seasonName: String(item.season?.name ?? '—'),
                    subtournamentName: item.subtournament?.name ?? '—',
                    total,
                    average,
                };
            })
            .filter((x): x is SeasonShotZonesTableRow => !!x);

        /*
        const dir = this.sortDirection === 'asc' ? 1 : -1;
        const field = this.sortField;

        // řadíme podle TOTAL (config přes @Input)
        return mapped.sort((a, b) => {
            const av = a.total[field] ?? 0;
            const bv = b.total[field] ?? 0;
            return (av - bv) * dir;
        });
         */
        return mapped;
    }

    private toTotals(stats: ShotZoneStats | null): ZoneTotals {
        return {
            goals: stats?.goals ?? 0,
            shots: stats?.shots ?? 0,
            missed_shots: stats?.missed_shots ?? 0,
            blocked_att: stats?.blocked_att ?? 0,
            shot_att: stats?.shot_att ?? 0,
        };
    }

    private sumZones(zones: ShotZonesMap): ZoneTotals {
        const sum: ZoneTotals = { goals: 0, shots: 0, missed_shots: 0, blocked_att: 0, shot_att: 0 };

        Object.values(zones ?? {}).forEach(z => {
            if (!z) return;
            sum.goals += z.goals ?? 0;
            sum.shots += z.shots ?? 0;
            sum.missed_shots += z.missed_shots ?? 0;
            sum.blocked_att += z.blocked_att ?? 0;
            sum.shot_att += z.shot_att ?? 0;
        });

        return sum;
    }

    private hasAnyValue(s: ZoneTotals): boolean {
        return (s.goals + s.shots + s.missed_shots + s.blocked_att + s.shot_att) > 0;
    }

    trackBySeasonRow(index: number, row: { key: string }) {
        return row.key;
    }
}
